import { render, staticRenderFns } from "./TableOrders.vue?vue&type=template&id=3c9f553a"
import script from "./TableOrders.vue?vue&type=script&lang=js"
export * from "./TableOrders.vue?vue&type=script&lang=js"
import style0 from "./TableOrders.vue?vue&type=style&index=0&id=3c9f553a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports